import { SwiperOptions } from "swiper/types";
import { Scrollbar } from "swiper/modules";

export const cardSliderOptions: SwiperOptions = {
  spaceBetween: 30,
  slidesPerGroup: 1,
  slidesPerView: 3,
  grabCursor: true,
  modules: [Scrollbar],
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
    draggable: true,
  },
  // pagination: {
  //   clickable: true,
  //   type: 'bullets'
  // },
  injectStyles: [
    `
      .swiper {
        overflow: visible;
      }
      .swiper-pagination {
        padding: 30px;
        display: flex;
        position: relative;
        bottom: 0;
        gap: var(--swiper-pagination-bullet-horizontal-gap);
        justify-content: center;
      }
      .swiper-pagination-bullet {
        transition: width .2s ease-out, background-color 0.2s;
        --swiper-pagination-bullet-horizontal-gap: 0;
      }
      .swiper-pagination-bullet-active {
        width: 40px;
      }
    `,
  ],
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 15,
    },
    480: {
      slidesPerView: 1,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    1190: {
      slidesPerView: 2,
    },
    1500: {
      slidesPerView: 3,
    },
    1600: {
      slidesPerView: 3,
    },
  },
};
